export enum PaymentTermsMode {
  Net = 'net',
  NetEndOfMonth = 'netEndOfMonth',
  OnReceipt = 'onReceipt',
}
